import axios from "axios";
import { API_ROOT } from "../constants";
import { trackEvent, EC_SHOP, E_ADD_TO_BASKET, E_REMOVE_FROM_BASKET } from "../helpers/tracking";
import { isTheSameLineItem } from "../helpers";

export const BASKET_UPDATE_START = "BASKET_UPDATE_START";
export const BASKET_UPDATE_SUCCESS = "BASKET_UPDATE_SUCCESS";
export const BASKET_UPDATE_FAIL = "BASKET_UPDATE_FAIL";

export const BASKET_GET_START = "BASKET_GET_START";
export const BASKET_GET_SUCCESS = "BASKET_GET_SUCCESS";
export const BASKET_GET_FAIL = "BASKET_GET_FAIL";

export function updateBasket(changes) {
	return function (dispatch, getState) {

		dispatch({ type: BASKET_UPDATE_START });

		const { session: { token }, vendor } = getState();

		// Cancel if no vendor.
		if (!vendor) return dispatch({
			type: BASKET_UPDATE_FAIL,
			message: "No vendor passed."
		});

		axios.put(`${API_ROOT}/basket/${vendor.id}`, changes, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(basket => {

			dispatch({
				type: BASKET_UPDATE_SUCCESS,
				basket
			});

		}).catch(error => {
			let message;
			if (error.response) {
				message = error.response.data.message;
			} else if (error.request) {
				message = "No response from server."
			} else if (error.message) {
				message = error.message;
			} else {
				message = "Unknown error.";
				console.error("Unknown error: ", error);
			}
			dispatch({
				type: BASKET_UPDATE_FAIL,
				message
			});
		});
	}
}

export function getBasket() {
	return function (dispatch, getState) {

		dispatch({ type: BASKET_GET_START });

		const { session: { token }, vendor } = getState();

		axios.get(`${API_ROOT}/basket/${vendor.id}`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(basket => {
			dispatch({
				type: BASKET_GET_SUCCESS,
				basket
			});
		}).catch(error => {
			let message;
			if (error.response) {
				message = error.response.data.message;
			} else if (error.request) {
				message = "No response from server."
			} else if (error.message) {
				message = error.message;
			} else {
				message = "Unknown error.";
				console.error("Unknown error: ", error);
			}
			dispatch({
				type: BASKET_GET_FAIL,
				message
			});
		});
	}
}

export function addProduct(product, quantity = 1, options = []) {
	return function (dispatch, getState) {

		const { basket: { items } } = getState();

		const match = items
			.find(item => isTheSameLineItem(item, { product, options }));

		let newItems;

		if (match) {
			newItems = items.map(item => (
				item === match ? {
					...item,
					quantity: item.quantity + quantity
				} : item
			));
		} else if (quantity > 0) {
			newItems = [
				...items,
				{ product: { ...product }, quantity, options }
			];
		} else {
			// Otherwise there was an attempt to remove an item that doesn't exist.
			console.warn("Bad request to remove item.");
			return;
		}

		dispatch(updateBasket({
			items: newItems
				.filter(item => item.quantity > 0)
				.map(item => ({
					...item,
					product: item.product.id
				}))
		}));

		// Track the basket events.
		if (quantity > 0) {
			trackEvent(EC_SHOP, E_ADD_TO_BASKET, `${product.id}_${product.name}`);
		} else if (quantity < 1) {
			trackEvent(EC_SHOP, E_REMOVE_FROM_BASKET, `${product.id}_${product.name}`);
		}
	}
}